import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const changeVisitStatus = async ({ payload }) => {
  const token = localStorage.getItem("token");

  const response = await axios.post(`${__API_URL__}/api/photos/change_visit_status/`, payload, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useChangeVisitStatusMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: changeVisitStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["visit_schedule"] });
      queryClient.invalidateQueries({ queryKey: ["special_visit_sessions"] });
      queryClient.invalidateQueries({ queryKey: ["visits_status_dropdown"] });
      queryClient.invalidateQueries({ queryKey: ["visit_overview"] });
    },
  });
};

export default useChangeVisitStatusMutation;
